import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default function initPartnersSlider(selector = '.ks-partners__swiper') {
  const sliders = document.querySelectorAll(selector);

  sliders.forEach((el) => {
    const root = el.closest('.ks-partners__slider') || el.parentElement;
    const nextEl = root ? root.querySelector('.ks-partners__nav-next') : null;
    const prevEl = root ? root.querySelector('.ks-partners__nav-prev') : null;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: { nextEl, prevEl },
      roundLengths: true,
      breakpoints: {
        992: { slidesPerView: 2 },
      },
    });
  });
}
